export default "__VITE_ASSET__f141fa0a__"